var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-input"},[_c('label',[_c('b',[_vm._v(_vm._s(_vm.label))])]),_c('DxDateBox',{attrs:{"disabled":_vm.readOnly,"stylingMode":"outlined","show-clear-button":true,"value":_vm.displayDate},on:{"value-changed":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }